import get from "lodash/get";
import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { useParams } from "react-router-dom-v5-compat";
import searchOperations from "../search/ducks/operations";
import AddContact from "./AddContact";
import AddContactToolbar from "./AddContactToolbar";
import actions from "./ducks/actions";
import operations from "./ducks/operations";

const AddContactContainer = (props) => {
    const { id } = useParams();
    const { flushContactState, getContact, location } = props;
    useEffect(() => {
        if (!location.state?.newContact === true) {
            if (id) {
                getContact(id);
            }
            ReactGA.send({ hitType: "pageview", page: "/contacts/*", title: `Edit Contact: ${id}` });
        } else {
            ReactGA.send({ hitType: "pageview", page: "/contacts/create", title: "Create New Contact" });
        }

        return () => {
            flushContactState();
        };
    }, [id]);

    if (
        get(props, "auth.userProfile.user") === get(props, "contact.owner.username") ||
        get(props, "location.state.newContact")
    ) {
        return (
            <React.Fragment>
                <AddContactToolbar {...props} newContact={get(props, "location.state.newContact")} />
                <AddContact {...props} newContact={get(props, "location.state.newContact")} />
            </React.Fragment>
        );
    }
    return null;
};

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer,
        errors: state.utilsReducer.errors.contact,
        contacts: state.crmReducer.contacts,
        contact: state.crmReducer.contact,
        reminders: state.crmReducer.contact.reminders,
        remindersActive: state.crmReducer.contact.remindersActiveFlg,
        autocompleteResults: state.searchReducer.autocompleteResults,
        elementsSaving: state.utilsReducer.elementsSaving,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContact: (contactId) => {
            dispatch(operations.getContact(contactId));
        },
        handleInput: (field, value) => {
            dispatch(actions.handleInput(field, value));
        },
        addArrayElement: (path, obj) => {
            dispatch(operations.addArrayElement(path, obj));
        },
        deleteArrayElement: (path, index) => {
            dispatch(operations.deleteArrayElement(path, index));
        },
        updateArrayElement: (path, index, field, value) => {
            dispatch(actions.handleInput(path + "[" + index + "]." + field, value));
        },
        handleSearchCompany: (searchTerm, companyType) => {
            dispatch(searchOperations.searchCompany(searchTerm, companyType));
        },
        createContact: () => {
            ReactGA.event("New Contact Created");
            return dispatch(operations.createContact());
        },
        updateContact: () => {
            ReactGA.event("Existing Contact Updated");
            return dispatch(operations.updateContact());
        },
        flushContactState: () => {
            dispatch(actions.handleInput("contact", {}));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddContactContainer);
